import React from "react";
import { useTheme } from "../contexts/ThemeContext";

const MOSQUE_BG = "https://customer-assets.emergentagent.com/job_noor-website-1/artifacts/t2chlxkt_F4324E15-5786-449E-AB3E-B234CA94436B.png";
const CLOUDS_BG = "https://customer-assets.emergentagent.com/job_noor-website-1/artifacts/5vnvv98c_82F798A9-AFBB-4481-9D21-1A506D73403D.png";

export default function AppLayout({ children }) {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const bgImage = isDark ? MOSQUE_BG : CLOUDS_BG;

  return (
    <div className="min-h-screen relative overflow-hidden">
      <div
        className="fixed inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
      <div
        className="fixed inset-0 z-0"
        style={{
          background: isDark
            ? "rgba(15, 23, 42, 0.65)"
            : "linear-gradient(to bottom, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.4) 40%, rgba(255,255,255,0.55) 100%)",
        }}
      />
      <div className="relative z-10 max-w-md mx-auto min-h-screen">
        {children}
      </div>
    </div>
  );
}
